import { GiStumpRegrowth, GiTreeGrowth } from "react-icons/gi";
import React, { Component } from "react";
import { iconSize, mobileSize } from "Themes/Metrics";

import Card from "react-bootstrap/Card";
import { Fonts } from "Themes";
import { GoRocket } from "react-icons/go";
import { MdUpdate } from "react-icons/md";
import { connect } from "react-redux";
import image01 from "Images/HomeScreen/08.png";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  align-items: stretch;
  padding: 0px 10px;
  @media ${mobileSize.large} {
    flex-direction: column;
  }
`;

const TextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px;
  cursor: pointer;
  font-family: ${Fonts.primaryFontFamily};
  margin-bottom: 20px;
`;

const Text = styled.div`
  padding: 20px;
  cursor: pointer;
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.fontSize.medium}px;
  border: solid 2px white;
`;

const ImageContainer = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

const InfoCard = styled(Card)`
  margin-bottom: 20px;
  z-index: 3;
  font-size: ${Fonts.fontSize.medium}px;
  padding: 10px;
  border: solid 2px white;
  &:hover {
    border: solid 2px lightgray;
  }
`

class HomeScreen extends Component {
  render() {
    const { history } = this.props;
    return (
      <Container>
        <ImageContainer
          onClick={() => (window.location = "https://absurd.design/")}
        >
          <img
            src={image01}
            alt={"not found"}
            title={"https://absurd.design/"}
            style={{
              height: 500,
              width: 500,
            }}
          />
        </ImageContainer>
        <TextContainer>
          <InfoCard
            onClick={() => history.push(navRoutes.createProject)}
          >
            <Text>
              <GiStumpRegrowth fontSize={iconSize.medium} /> Create a snapshot of your latest
              project
            </Text>
          </InfoCard>
          <InfoCard
            onClick={() => history.push(navRoutes.updateFeed)}
          >
            <Text>
              {" "}
              <MdUpdate fontSize={iconSize.medium} /> Post high quality weekly updates
            </Text>
          </InfoCard>
          <InfoCard
            onClick={() => history.push(navRoutes.updateFeed)}
          >
            <Text>
              {" "}
              <GiTreeGrowth fontSize={iconSize.medium} /> Incremental updates are the key to
              a successful project!
            </Text>
          </InfoCard>
          <InfoCard
            onClick={() => history.push(navRoutes.updateFeed)}
          >
            <Text>
              <GoRocket fontSize={iconSize.medium} /> Get Started!
            </Text>
          </InfoCard>
        </TextContainer>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeScreen);
